<template>
  <div class="w-100">
    <div :class="$style.matchesLinkWrapper">
      <b-container>
        <b-row class="py-3 px-2">
          <b-col class="pl-0">
            {{ $tc('x-friends', friendsCount, { x: friendsCount }) }}
          </b-col>
          <b-col class="text-right pr-0">
            <template v-if="friendsCount && round.status === roundStatuses.upcoming">
              <a
                href="#"
                @click="handleUpcomingRoundPoolOverviewModal"
              >
                {{ $t('see-pool-details') }}
                <font-awesome-icon icon="angle-right" />
              </a>
              <TheUpcomingRoundPoolOverviewModal
                v-if="isUpcomingRoundPoolOverviewModalOpen"
                :round-id="round.id"
                @close="isUpcomingRoundPoolOverviewModalOpen = false"
              />
            </template>
            <router-link
              v-else
              :to="{name: 'my-friends-page'}"
            >
              <span v-if="friendsCount">{{ $t('see-pool-details') }}</span>
              <span v-else>{{ $t('invite-friends') }}</span>
              &nbsp;
              <font-awesome-icon icon="angle-right" />
            </router-link>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <UpcomingSummerRound
      v-if="round.status === roundStatuses.upcoming"
      :athletes="selectedAthletes"
      :round-id="round.id"
      :round="round"
      :matches="round.matches"
      @onAthletePickRemove="$emit('onAthletePickRemove')"
      @onMatchScoreChange="handleMatchScoreChange"
    />
    <LiveAndClosedSummerRound
      v-else
      :round-id="round.id"
      :round="round"
      :matches="round.matches"
      :round-statuses="roundStatuses"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { buildNotification } from '@/helpers/ui'
import UpcomingSummerRound from '../../Components/Organisms/Summer/UpcomingSummerRound'
import LiveAndClosedSummerRound from '../../Components/Organisms/Summer/LiveAndClosedSummerRound'
import TheUpcomingRoundPoolOverviewModal from '../../Components/Organisms/Summer/Modals/TheUpcomingRoundPoolOverviewModal'

export default {
  name: 'RoundDetailSummer',
  components: { TheUpcomingRoundPoolOverviewModal, LiveAndClosedSummerRound, UpcomingSummerRound },
  props: {
    round: {
      type: Object,
      default: () => {},
    },
    roundStatuses: {
      type: Object,
      default: () => {},
    },
    selectedAthletes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isUpcomingRoundPoolOverviewModalOpen: false,
    }
  },
  computed: {
    ...mapGetters({
      friendsCount: 'auth/getFriendsCount',
    }),
  },
  methods: {
    ...mapActions({
      setMatchScore: 'rounds/summer/matchScore/setMatchScore',
    }),
    handleUpcomingRoundPoolOverviewModal(e) {
      e.preventDefault()
      this.isUpcomingRoundPoolOverviewModalOpen = true
    },
    handleMatchScoreChange(params) {
      this.setMatchScore(params)
      buildNotification({
        title: this.$t('your-score-prediction-was-saved'),
      })
    },
  },
}
</script>

<style module lang="scss">
  @import "../../../../assets/scss/variables";
  .matchesLinkWrapper {
    background-color: $color-bleached-silk;
    border-bottom: 1px solid $color-jupiter;
  }
</style>
